<template>
  <div>
  <div class="book-details">
    <div class="left-panel">
      <BigBookItem :src="book.coverUrl" />
      <div class="buttons" v-if="isLogin">
       
        <LoadingButton v-show="isInShelf" :buttonText="'取消收藏'" :loading="shelfLoading" @button-click="addToShelf"></LoadingButton>
        <LoadingButton v-show="!isInShelf" :buttonText="'收藏'" :loading="shelfLoading" @button-click="addToShelf"></LoadingButton>

        <LoadingButton :buttonText="'阅读'" :loading="lock" @button-click="startReading"></LoadingButton>

        <LoadingButton :buttonText="'下载'" :loading="downloadLoading" @button-click="downloadBook"></LoadingButton>
      </div>
      <!-- <div class="bookShelf">
        <div class="title">相关推荐</div>
        <BookShelf @redirectBook="redirectBook()" :bookList="recommends" v-show="!recommendLoading"></BookShelf>
      </div> -->
    </div>  
    <div class="right-panel">
      <h1>{{ book.title }}</h1>
      <div class="info">
        <div>作者: 
          <span v-for="(author, index) in book.author" :key="index">
            {{ author }}
            <!-- 只在不是最后一个作者时添加斜杠 -->
            <span v-if="index !== book.author.length - 1"> / </span>
          </span>
        </div>
        <div>年代: {{ book.year }}</div>
        <div>出版社: {{ book.publisher }}</div>
      </div>
      <div class="description" v-html="book.description">
      </div>
    </div>
  </div>
  <div class="bookShelf1">
      <div class="title">相关推荐</div>
      <BookShelf @redirectBook="redirectBook()" :bookList="recommends" v-show="!recommendLoading"></BookShelf>
    </div>
  </div>
</template>


<script>
import { getBook, getIfShelf, delShelf, addShelf, downloadBook, readPdf } from '@/_api/book';
import BookShelf from '@/components/BookShelf.vue';
export default {
    name: "BookView",
    data() {
        return {
            isLogin: false,
            book: {},
            isInShelf: false,
            bookMd5: 0,
            lock: false,
            shelfLoading: true,
            shelfId: 0,
            downloadLoading: false,
            lastParams: {},
            lastCase: '',
            recommends: [],
            recommendLoading: false
        };
    },
    created() {
        this.bookMd5 = this.$route.params.id;
        this.getAuthorizeSetting();
        this.getBookInfo(this.bookMd5);
        this.getIfShelf(this.bookMd5);
        console.log('created', this.bookMd5);
    },
    methods: {
      redirectBook() {
        this.bookMd5 = this.$route.params.id;
        this.getAuthorizeSetting();
        this.getBookInfo(this.bookMd5);
        this.getIfShelf(this.bookMd5);
      },
        // getRecommend() {
        //   getRecommend().then((res) => {
        //     if (res.status == 'ok') {
        //       res.data.results.forEach(recommend => {
        //         recommend.bookMd5 = recommend.title;
        //       });
        //       this.recommends = res.data.results
        //     }
        //   }).finally(() => {
        //     this.recommendLoading = false
        //   })
        // },
        downloadPDF(pdfContent) {
            const url = window.URL.createObjectURL(new Blob([pdfContent]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();
        },
        addToShelf() {
            if (this.shelfLoading)
                return;
            this.shelfLoading = true;
            if (this.isInShelf) {
                delShelf({
                    shelfId: this.shelfId,
                }).then((res) => {
                    if (res.status == 'ok') {
                        this.isInShelf = !this.isInShelf;
                    }
                    this.shelfLoading = false;
                });
            }
            else {
                addShelf({
                    md5: this.bookMd5,
                    title: this.book.title,
                    coverUrl: this.book.coverUrl_copy
                }).then((res) => {
                    if (res.status == 'ok') {
                        this.isInShelf = !this.isInShelf;
                    }
                    this.shelfLoading = false;
                    this.getIfShelf(this.bookMd5)
                });
            }
        },
        getIfShelf(md5) {
            getIfShelf({
                md5: md5
            }).then((res) => {
                if (res.status == 'ok') {
                    this.isInShelf = res.data.isInShelf;
                    this.shelfId = res.data.shelfId;
                }
            }).finally(() => {
                this.shelfLoading = false;
            });
        },
        getAuthorizeSetting() {
            const token = localStorage.getItem('token');
            if (token) {
                this.isLogin = true;
            }
        },
        getBookInfo(md5) {
            getBook(md5).then((res) => {
                if (res.status = 'ok') {
                    this.book = res.data.book
                    this.recommends = res.data.relatedBook
                    this.book.coverUrl_copy =  this.book.coverUrl
                    this.book.coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.book.coverUrl
                    for(let i = 0; i < this.recommends.length ; i++) {
                      this.recommends[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" +this.recommends[i].coverUrl
                    }

                    const containerElement = document.querySelector('.nav').scrollIntoView({
                      behavior: "smooth", // 平滑过渡
                      block: "start", // 上边框与视窗顶部平齐。默认值
                    })
                    
                }
            });
        },
        startReading() {
          if (this.book.extension == 'pdf') {
            if (this.lock) return
            this.lock = true
            readPdf({
              md5: this.book.md5,
              title: this.book.title,
              coverUrl: this.book.coverUrl_copy,
              extension: this.book.extension
            }).then((res) => {
              this.imgUrl = window.URL.createObjectURL(res)
              window.open(this.imgUrl)
              // window.open('/pdfjs/web/viewer.html?file=' +encodeURIComponent(res));
            }).finally(() => {
              this.lock = false
            })
          }
          // this.$router.push({
          //   path: '/ebook/'+ this.book.md5,
          // });
        },
        downloadBook() {
            if (this.downloadLoading)
                return;
            this.downloadLoading = true;
            downloadBook({
                md5: this.bookMd5,
                extension: this.book.extension,
                title: this.book.title,
                coverUrl: this.book.coverUrl_copy
            }).then((res) => {
                console.log('downloadBook', res);
                if (res.status == 'ok') {
                  this.downloadPDF(res);
                }else if (res.response?.status == 403) {
                  this.$message.error("您的组织没有该类书籍的下载权限，请联系管理员")
                } else {
                  this.$message.error("出错了")
                }
            }).finally(() => {
                this.downloadLoading = false;
            });
            // Logic to download the book
        }
    },
    components: { BookShelf }
};
</script>

<style lang="less">
.book-details {
  display: flex;
  @media screen and (max-width:730px) {
    flex-direction: column;
    align-items: center;
  }
}

.left-panel {
  padding-top: 50px;
  width: 40vw;
  max-width: 600px;
  @media screen and (max-width:730px) {
    width: 360px;
    .m-button {
      width: 80px;
      font-size: 12px;
      letter-spacing: 1px;
    }
  }
}

.right-panel {
  padding: 10px;
  flex: 1;
  @media screen and (max-width:730px) {
    width: 80vw;
    margin: 30px auto 50px auto;
    .info {
      font-style: italic;
      padding: 20px 0;
    }
  }
  .info {
      display: flex;
      flex-direction: column;
      gap: 5px;
      font-style: italic;
      padding: 20px 0;
    }
}

.buttons {
  display: flex;
  justify-content: space-evenly;
  margin-top: 80px;
  button {
    color: white;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
  }
}

.loading {
  position: relative;
}

.bookShelf {
  .title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  padding: 20px 5%;
  @media screen and (max-width:730px) {
    display: none;
  }
}
.bookShelf1 {
  .title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  width: 96vw;
  margin: auto;
  padding: 30px;
  // display: none;
  @media screen and (max-width:730px) {
    display: block;
  }
}

.loading:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

</style>
